/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for MentionResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { MentionListDTO, RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class MentionResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    addMention(mentionListDTO: MentionListDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<MentionListDTO>;
    addMention(mentionListDTO: MentionListDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<MentionListDTO>>;
    addMention(mentionListDTO: MentionListDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<MentionListDTO>>;
    addMention(mentionListDTO: MentionListDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/mentions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: mentionListDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    updateMention(mentionListDTO: MentionListDTO, observe?: 'body', options?: RequestOptions<'json'>): Observable<MentionListDTO>;
    updateMention(mentionListDTO: MentionListDTO, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<MentionListDTO>>;
    updateMention(mentionListDTO: MentionListDTO, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<MentionListDTO>>;
    updateMention(mentionListDTO: MentionListDTO, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/mentions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: mentionListDTO,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getMentions(idDomaine: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<MentionListDTO>>;
    getMentions(idDomaine: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<MentionListDTO>>>;
    getMentions(idDomaine: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<MentionListDTO>>>;
    getMentions(idDomaine: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/mentions/${idDomaine}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
